import { render, staticRenderFns } from "./PaymentMethodPanel.vue?vue&type=template&id=35b7b948&scoped=true&"
import script from "./PaymentMethodPanel.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7b948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b7b948')) {
      api.createRecord('35b7b948', component.options)
    } else {
      api.reload('35b7b948', component.options)
    }
    module.hot.accept("./PaymentMethodPanel.vue?vue&type=template&id=35b7b948&scoped=true&", function () {
      api.rerender('35b7b948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/components/scheduled/PaymentMethodPanel.vue"
export default component.exports